import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as cafeDiscountActions from '../../../redux/cafeDiscounts/actions';
import CafeDiscountRequestArchivesTable from './cafeDiscountRequestsTable';
import Spin from '../../../components/loading';
import Pagination2 from '../../../components/Pagination2';
import CafeDiscountRequestArchivesFilter from './cafeDiscountRequestsFilter';
import submitForm from '../../../utils/submitForm';

class CafeDiscountRequestArchives extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      itemsPerPage: 10,
      cafeIds: [],
      sortType: 'asc',
      sortBy: 'createdAt'
    };
  }

  componentDidMount() {
    this.sortTable(this.state.sortBy);
  }

  sortTable = query => {
    this.setState({ sortType: this.state.sortType == 'asc' ? 'desc' : 'asc' }, () => {
      query = `${query}-${this.state.sortType}`;
      this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
    });
  };

  applyFilters = event => {
    const filter = submitForm(event, [], [], this.state.cafeIds);
    this.setState({ filter }, () => this.filterAndSort());
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) query = `${filter}&${sort}`;
    else if (filter) query = `${filter}`;
    else if (sort) query = `${sort}`;
    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      console.log('filter===>>', searchQuery);
      this.props.fetchAllCafeDiscountRequestArchives(searchQuery);
    });
  };

  onSelectCafeIds = cafeIds => {
    this.setState({ cafeIds: cafeIds ? [...cafeIds] : [cafeIds] });
  };

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      console.log('pageNumber is: ', pageNumber);
      console.log('pageSize is: ', pageSize);
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;

    console.log('pagination data: ', data);

    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllCafeDiscountRequestArchives(query);
    });
  };

  render() {
    let {
      cafeDiscountRequestArchivesLoading,
      cafeDiscountRequestArchivesMessage,
      cafeDiscountRequestArchivesFailed,
      cafeDiscountRequestArchivesError
    } = this.props;

    let { totalRecords } = this.props.cafeDiscountRequestArchives;

    let { currentPage, itemsPerPage } = this.state;
    return (
      <>
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h3 className="text-right text-muted py-4">
            <div className="text-right">{locales('titles.cafeDiscountRequestsArchive')}</div>
          </h3>
        </div>
        <section className="p-1 col-12">
          <Spin spinning={cafeDiscountRequestArchivesLoading}>
            <article>
              <main className="panel panel-default">
                {cafeDiscountRequestArchivesError ? (
                  <div className="alert alert-danger">{locales('messages.server.error')}</div>
                ) : (
                  <>
                    {cafeDiscountRequestArchivesFailed && (
                      <div className="alert alert-danger">{cafeDiscountRequestArchivesMessage}</div>
                    )}
                    <div className="panel-heading">
                      <i className="fas fa-list-alt px-1" />
                      {locales('titles.cafeDiscountRequestsArchiveList')}
                    </div>
                    <div className="panel-body">
                      <CafeDiscountRequestArchivesFilter
                        onSelectCafeIds={this.onSelectCafeIds}
                        applyFilters={this.applyFilters}
                        filterAndSort={this.filterAndSort}
                        pageNumber={this.state.currentPage}
                      />
                      <CafeDiscountRequestArchivesTable
                        pageNumber={currentPage}
                        pageSize={itemsPerPage}
                        sortTable={this.sortTable}
                        fromArchive={true}
                        pageSize={itemsPerPage}
                      />
                      <footer className="col-12 d-flex justify-content-center py-2">
                        <div className="pagination-container">
                          <Pagination2
                            totalRecords={totalRecords || 0}
                            pageLimit={itemsPerPage}
                            pageNeighbours={2}
                            onPageChanged={this.onPageChanged}
                            currentPage={this.state.currentPage}
                          />
                        </div>
                      </footer>
                    </div>
                  </>
                )}
              </main>
            </article>
          </Spin>
        </section>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    cafeDiscountRequestArchivesList: state.cafeDiscountsReducer.cafeDiscountRequestArchivesList,
    cafeDiscountRequestArchives: state.cafeDiscountsReducer.cafeDiscountRequestArchives,
    cafeDiscountRequestArchivesLoading: state.cafeDiscountsReducer.cafeDiscountRequestArchivesLoading,
    cafeDiscountRequestArchivesMessage: state.cafeDiscountsReducer.cafeDiscountRequestArchivesMessage,
    cafeDiscountRequestArchivesFailed: state.cafeDiscountsReducer.cafeDiscountRequestArchivesFailed,
    afeDiscountRequestArchivesError: state.cafeDiscountsReducer.cafeDiscountRequestArchivesError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAllCafeDiscountRequestArchives: query =>
      dispatch(cafeDiscountActions.fetchAllCafeDiscountRequestArchives(query))
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CafeDiscountRequestArchives)
);
